import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Helper } from './helper.service';
import { UserModel } from '../models/user/user.model';
import { catchError, Observable } from 'rxjs';
import { EmailManagerModel } from '../models/email-manager.model';
import { EmailModelDTO } from '../models/email-manager.model.dto';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class EmailManagerService {
  options: any;
  emailManagers: Observable<any> = new Observable<any>();
  user: UserModel | null = null;
  constructor(
    private http: HttpClient,
    private helperService: Helper,
  ) {}

  getEmailManagers(): Observable<any> {
    this.options = { headers: this.helperService.getApiAuthHeader() };
    return this.http.get(environment.emailManagerServiceEndPoint, this.options).pipe(catchError((error) => this.helperService.handleError(error)));
  }

  updateEmailManager(newEmailManager: EmailManagerModel): Observable<any> {
    this.options = { headers: this.helperService.getApiAuthHeader() };
    return this.http
      .put(environment.emailManagerServiceEndPoint + '/' + newEmailManager.id, JSON.stringify(newEmailManager), this.options)
      .pipe(catchError((error) => this.helperService.handleError(error)));
  }

  saveEmailManager(newEmailManager: EmailManagerModel): Observable<any> {
    this.options = { headers: this.helperService.getApiAuthHeader() };
    return this.http.post(environment.emailManagerServiceEndPoint, JSON.stringify(newEmailManager), this.options).pipe(catchError((error) => this.helperService.handleError(error)));
  }

  sendEmail(newEmail: EmailModelDTO): Observable<any> {
    this.options = { headers: this.helperService.getApiAuthHeader() };
    return this.http.post(environment.emailManagerServiceEndPoint + '/sendEmail', JSON.stringify(newEmail), this.options).pipe(catchError((error) => this.helperService.handleError(error)));
  }

  setEmailManagers(emailManager: EmailManagerModel) {
    sessionStorage.setItem('emailManagers', JSON.stringify(emailManager));
  }
}
